<template lang="pug">
  .financing-callout
    p.icon
      svg(height="40" width="40" enable-background="new 0 0 32.9 33" version="1.1" viewBox="0 0 32.9 33" xml:space="preserve" xmlns="http://www.w3.org/2000/svg")
        switch
          foreignObject(width="1" height="1" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/")
          g
            g(transform="translate(-172 -1565)")
              g(transform="translate(172 1565)")
                circle(style="fill:none" cx="16.4" cy="16.2" r="15.5")
                circle(style="fill:none;stroke:#285181;stroke-width:1.75;" cx="16.4" cy="16.2" r="14.8")
              text(style="fill:#285181" transform="translate(183.88 1586.6)") $

    h3
      a(href="https://hamptonridgefinancial.com/mitylite/" target="_blank") Need Financing?
    p MityLite now offers financing for purchases <strong>$3,000 and more!</strong>

</template>

<script>
export default {
  name: "Financing",
  props: [],
  data() {
    return {
      assetsURL: this.defineEnvironment()
    };
  },
  methods: {
    defineEnvironment() {
      let URL = window.location.hostname;

      if (URL.indexOf("local") > -1) {
        return "../../static/img/";
      } else if (URL.indexOf("staging") > -1) {
        return "https://storage.googleapis.com/mity-quotes-cart/public/beta/img/";
      } else {
        return "https://storage.googleapis.com/mity-quotes-cart/public/beta-stable/img/";
      }
    }
  },
  created: function() {}
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";

//GLOBALS
#app {
  .financing-callout {
    background: #f5f5f5;
    margin-top: 1em;
    padding: 0.1em 1em 1em;
    text-align: center;
    p {
      color: gray;
      margin: 1em 0;
      padding: 0;

      &.icon {
        margin: 1em 0 0.5em;
        padding: 0;
      }

      img {
        height: auto;
        width: 40px;
      }
    }
    h3 {
      font-size: 1.1em;
      font-weight: 500;
    }
    strong {
      font-weight: 500;
    }
  }
  .auth .container .financing-callout p {
    padding-bottom: 0;
  }
}
</style>
